/* eslint-disable */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import Link from 'next/link';
import React, { Children } from 'react';

const ActiveLink = ({ children, activeClassName, checkForNested, ...props }) => {
  const { asPath } = useRouter();
  const child = Children.only(children);
  const childClassName = child.props.className || '';

  const matched = checkForNested
    ? asPath.startsWith(props.href) || asPath.startsWith(props.as)
    : asPath === props.href || asPath === props.as;

  // pages/index.js will be matched via props.href
  // pages/about.js will be matched via props.href
  // pages/[slug].js will be matched via props.as
  const className = matched ? `${childClassName} ${activeClassName}`.trim() : childClassName;

  return (
    <Link {...props}>
      {React.cloneElement(child, {
        className: className || null,
      })}
    </Link>
  );
};

ActiveLink.defaultProps = {
  checkForNested: false,
};

ActiveLink.propTypes = {
  activeClassName: PropTypes.string.isRequired,
  checkForNested: PropTypes.bool,
};

export default ActiveLink;
